import { render, staticRenderFns } from "./dangerGoods.vue?vue&type=template&id=e6a33142&scoped=true"
import script from "./dangerGoods.vue?vue&type=script&lang=js"
export * from "./dangerGoods.vue?vue&type=script&lang=js"
import style0 from "./dangerGoods.vue?vue&type=style&index=0&id=e6a33142&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a33142",
  null
  
)

export default component.exports